module.exports = __webpack_public_path__ + "media/images/icon-marker-7974f77b0434c9ec944e5f2981d4a739.svg";